<template>
  <div class="PdfModal" @click="emit('cancel')">
    <div class="PdfModal-page" @click.stop>
      <!-- iframe с PDF -->
      <div class="PdfModal-iframe">
        <iframe :src="pdfUrl" type="application/pdf" width="100%"></iframe>
      </div>

      <!-- Кнопки управления -->
      <div class="p-3">
        <ui-button class="btn-base me-1" @click="emit('sign')" :loading="props.loadingSigned">Да, подписать</ui-button>
        <ui-button class="btn-ghost" @click="emit('cancel')" :disabled="props.loadingSigned">Нет, отменить</ui-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import './style.css'

// Props
const props = defineProps({
  base64: {
    type: String,
    required: true,
  },
  loadingSigned: {
    type: Boolean,
  }
})

// Эмиттер
const emit = defineEmits(['cancel', 'sign'])

// Вычисляемая ссылка на pdfUrl
const pdfUrl = computed(() => {
  if (!props.base64.startsWith('data:application/pdf;base64,')) {
    return `data:application/pdf;base64,${props.base64}`
  }
  return props.base64
})

// Скрытие скролла при монтировании
onMounted(() => {
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>